import {inject, Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({standalone: true, name: 'matchDatePipe'})
export class MatchDatePipe implements PipeTransform
{
  private datePipe = inject(DatePipe);

  transform(dateValue: Date, params?: string): string
  {
    if (dateValue)
    {
      const date = new Date(dateValue);
      if (date.getHours() > 0 || date.getMinutes() > 0)
      {
        if (params && params === 'full')
          return this.datePipe.transform(date, 'dd.MM.yy HH:mm');
        else return this.datePipe.transform(date, 'dd.MM. HH:mm');
      }
      return this.datePipe.transform(date, 'dd.MM.yy');
    }
    return '';
  }
}
